export default {
    MESSAGE : 'MESSAGE',
    CALL : 'CALL',
    ACTION : 'ACTION',
}
